import { render, staticRenderFns } from "./Centros.vue?vue&type=template&id=d6775284"
import script from "./Centros.vue?vue&type=script&lang=js"
export * from "./Centros.vue?vue&type=script&lang=js"
import style0 from "./Centros.vue?vue&type=style&index=0&id=d6775284&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports